<app-infobox [pointData]="pointData"></app-infobox>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/widgets/value/spesa-media-carta-indicator/spesa-media-carta-indicator.component.html